import { request } from './http';
import type {
  GrowthResponse,
  GrowthPlan,
  GrowthFeedback,
} from '@shared/util/growth';
export type {
  GrowthResponse,
  GrowthPlan,
  GrowthFeedback,
  GrowthOpportunity,
} from '@shared/util/growth';

const path = (projectId: string) =>
  `/project/${encodeURIComponent(projectId)}/growth`;
export const getGrowth = (projectId: string) =>
  request<GrowthResponse>(path(projectId), 'GET');
export const savePlan = (projectId: string, plan: GrowthPlan) =>
  request<GrowthResponse, GrowthPlan>(path(projectId), 'PUT', plan);
export const saveFeedback = (
  projectId: string,
  id: string,
  feedback: GrowthFeedback,
) =>
  request<GrowthResponse, GrowthFeedback>(
    `${path(projectId)}/opportunities/${encodeURIComponent(id)}`,
    'PATCH',
    feedback,
  );
